import { Injectable } from '@angular/core';
import { WorkspaceFile } from '@common/workspace/models/workspace-file.model';
import { State, Store } from '@ngxs/store';
import { CollectionDataServiceBase } from '@portal-core/data/collection/services/collection-data.service.base';
import { CollectionStateSelectors } from '@portal-core/data/collection/services/collection-state-selectors.decorator';
import { CollectionStateBase } from '@portal-core/data/collection/services/collection-state.base';

@CollectionStateSelectors({
  stateType: WorkspaceFilesState
})
@State<WorkspaceFile>({
  name: WorkspaceFilesState.source
})
@Injectable()
export class WorkspaceFilesState extends CollectionStateBase {
  static source: string = 'WorkspaceFiles';
  getSource(): string {
    return WorkspaceFilesState.source;
  }
}

@Injectable({
  providedIn: 'root'
})
export class WorkspaceFilesDataService extends CollectionDataServiceBase<WorkspaceFile> {
  constructor(protected store: Store) {
    super(store, WorkspaceFilesState);
  }
}
